import React from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import "./Events.scss";

const Events = () => {
  return (
    <>
      <NavBar />
      <main className="eventsPage">
        <header className="eventsPage__hero">
          <div className="container">
            <span className="eyebrow">Events</span>
            <h1 className="section-heading">Future Events</h1>
            <p className="lede">
              Empowering local businesses through advocacy, networking, and
              resources.
            </p>
          </div>
        </header>

        <section className="eventsPage__intro">
          <div className="container">
            <h2 className="section-heading section-heading--sm">Upcoming Events</h2>
            <p className="lede">
              Join us for exciting events that foster networking, learning,
              and community growth. Whether you're looking to expand your
              business connections or learn new skills, ANZEG's events are
              the perfect opportunity.
            </p>
          </div>
        </section>

        <section className="eventsPage__list">
          <div className="container eventsPage__listInner eventsPage__empty">
            <p className="lede">
              There are no upcoming events at this time. Check back soon, or
              browse our{" "}
              <a href="/past-events">past events</a> in the meantime.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Events;
